module.exports = __webpack_public_path__ + "static/media/olive-style.53a8e7de.jpg";